<template>
  <main>
    <TopBanner/>
    <div>
      <h2><span class="invis">Bonjour {{ userPrenom }}</span>Accueil<span>Bonjour {{ userPrenom }}</span></h2>
      <article>
        <section class="clickable" @click="push('/orders/register')" :style="{backgroundColor: 'green'}">Prendre une commande</section>
        <section class="clickable" @click="push('/orders/make')" :style="{backgroundColor: 'orange'}">Préparer une commande</section>
        <section class="clickable" @click="push('/orders/store')" :style="{backgroundColor: 'royalBlue'}">Ranger une commande</section>
        <section class="clickable" @click="push('/orders/pickup')" :style="{backgroundColor: 'black'}">Récupérer une commande</section>
        <section class="clickable" @click="push('/admin/orders')">Gérer les commandes</section>
        <section v-if="permissions == 1" class="clickable" @click="push('/admin')" :style="{backgroundColor: 'DarkGreen'}">Administration</section>
        <section v-else class="clickable-disabled" :style="{backgroundColor: 'DarkGreen'}">Administration</section>
        <section v-if="permissions == 1" class="clickable" @click="push('/stats')" :style="{backgroundColor: 'red'}">Produits Consommés</section>
        <section v-else class="clickable-disabled" :style="{backgroundColor: 'red'}">Produits Consommés</section>
        <section class="clickable" @click="disconnect" :style="{backgroundColor: 'black'}">Se déconnecter</section>
      </article>
    </div>
  </main>
</template>

<script>
import TopBanner from '../templates/Banner.vue'

export default {
  name: 'DashBoard',
  components: {
    TopBanner
  },
  data () {
    return {
      permissions: 3
    }
  },
  computed: {
    userPrenom () {
      return localStorage.getItem('prenom')
    }
  },
  methods: {
    push (route) {
      this.$router.push(route)
    },
    disconnect () {
      localStorage.removeItem('id')
      localStorage.removeItem('pwd')
      localStorage.removeItem('permissions')
      this.$emit('dc')
    }
  },
  created () {
    this.permissions = localStorage.getItem('permissions')
  },
  mounted () {
    sessionStorage.clear()
  }
}
</script>

<style scoped>
h2 {
  display: flex;
  justify-content: space-evenly;
  width: 100%;
}
.invis {
  visibility: hidden;
}
main {
  font-size: clamp(1rem, 2vw, 1.25rem);
  width: 100%;
  min-height: 100dvh;
  max-height: 100dvh;
  overflow: hidden;
}
main > div {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  padding-bottom: 0.75rem;
  flex: 1;
  min-height: 0;
}
article {
  display: flex;
  justify-content: space-evenly;
  gap: 1rem;
  flex-wrap: wrap;
  width: 100%;
  height: 100%;
  max-height: 80vh;
  min-height: 0;
  overflow-y: auto;
  padding-inline: 0.25rem;
  padding-bottom: 2rem;
}
section {
  width: min(100%, 360px);
  padding: 10px;
  background-color: gray;
  opacity: 0.7;
  color: gainsboro;
  display: flex;
  justify-content: center;
  align-items: center;
  aspect-ratio: 16/9;
  font-size: clamp(1rem, 2vw, 1.2rem);
  font-weight: 900;
  border-radius: 16px;
}
@media screen and (min-width: 1200px) {
  article {
    display: flex;
    justify-content: space-evenly;
    gap: 1rem;
    flex-wrap: wrap;
    width: 90%;
  }
  section {
    width: min(30%, 320px);
    padding: 10px;
    background-color: gray;
    color: gainsboro;
    display: flex;
    justify-content: center;
    align-items: center;
    aspect-ratio: 16/9;
    font-size: clamp(1rem, 1.2vw, 1.2rem);
    font-weight: 900;
    border-radius: 16px;
  }
}
</style>
